export default "__VITE_ASSET__6cafdd6d__"